module.exports = __webpack_public_path__ + "static/media/Group_1000006631.5b229832.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group_1000006631.png
// module id = 1209
// module chunks = 0